import { inject, signal, Service } from '@angular/core';
import { DataAccessSystemService } from '@h5s/data-access-system';
import { take, tap } from 'rxjs';

@Service()
export class FeatureSystemService {
  /** Services */
  private readonly dataAccessSystemService = inject(DataAccessSystemService);

  private readonly _backendVersion = signal<string>('');
  public readonly backendVersion = this._backendVersion.asReadonly();

  /** Ottiene la versione del backend in esecuzione */
  public getBackendVersion(): void {
    this.dataAccessSystemService
      .getBackendVersion()
      .pipe(
        take(1),
        tap((response) => this._backendVersion.set(response.backend.version)),
      )
      .subscribe();
  }
}
